export const generateCustomizedSyncBody = (state$) => ({
  groups: state$.value.customizedautosync.self.syncAll
    ? []
    : state$.value.customizedautosync.self.interactedGroups,
  excludeMode: state$.value.customizedautosync.self.syncAll
    ? false
    : state$.value.customizedautosync.self.excludeMode,
  integrationType: state$.value.customizedautosync.self.integrationType,
  syncShared: state$.value.customizedautosync.self.includeSharedMailboxes,
})
